import type { PlaycastPlayjectorSourceProperties } from '@playcastdotio/CoreTypes';
import type {
  PlaycastMessage,
  PlaycastMessageCameraAutoPick,
  PlaycastMessageCameraGetSources,
  PlaycastMessageCameraSetProperties,
  PlaycastMessageCameraSetPicking,
  PlaycastMessageCameraSetSource,
  PlaycastMessageCameraStartStopToggle,
  PlaycastMessageSource,
  PlaycastCameraPropertiesUpdate,
} from '../types';
import { formatMessage } from './_util/formatMessage';

const target = 'camera';

/**
 * @experimental This is an experimental feature and may be changed in the future.
 */
export const getSources = (userAuth?: string): PlaycastMessage<PlaycastMessageCameraGetSources> => {
  const hostId = 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageCameraGetSources = {
    target,
    action: 'getSources',
    isReply: false,
    message: {},
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageCameraGetSources>;
};

/**
 * @experimental This is an experimental feature and may be changed in the future.
 */
export const setSource = (
  cameraName: string,
  sourceProperties: PlaycastPlayjectorSourceProperties,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageCameraSetSource> => {
  const hostId = 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageCameraSetSource = {
    target,
    action: 'setSource',
    isReply: false,
    message: {
      cameraName,
      sourceProperties,
    },
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageCameraSetSource>;
};

export const setProperties = (
  cameraName: string,
  cameraProperties: PlaycastCameraPropertiesUpdate,
  hostAuthId?: string,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageCameraSetProperties> => {
  const hostAuth = hostAuthId || 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageCameraSetProperties = {
    target,
    action: 'setProperties',
    isReply: false,
    message: {
      cameraName,
      cameraProperties,
    },
  };
  return formatMessage(hostAuth, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageCameraSetProperties>;
};

// /**
//  * @experimental This is an experimental feature and may be changed in the future.
//  */
// export const pickSource = (displayId: number, userAuth?: string): PlaycastMessage<PlaycastMessageCameraPickSource> => {
//   const hostId = 'experimental';
//   const messageSource: PlaycastMessageSource = 'host';
//   const message: PlaycastMessageCameraPickSource = {
//     target,
//     action: 'pickSource',
//     isReply: false,
//     message: {
//       displayId,
//     },
//   };
//   return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageCameraPickSource>;
// };

export const setPicking = (enabled: boolean, hostAuthId?: string, userAuth?: string): PlaycastMessage<PlaycastMessageCameraSetPicking> => {
  const hostAuth = hostAuthId || 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageCameraSetPicking = {
    target,
    action: 'setPicking',
    isReply: false,
    message: {
      enabled,
    },
  };
  return formatMessage(hostAuth, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageCameraSetPicking>;
};

export const autoPick = (cameraName: string, enabled: boolean, userAuth?: string): PlaycastMessage<PlaycastMessageCameraAutoPick> => {
  const hostId = 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageCameraAutoPick = {
    target,
    action: 'autoPick',
    isReply: false,
    message: {
      cameraName,
      enabled,
    },
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageCameraAutoPick>;
};

export const startStopToggle = (
  cameraName: string,
  active: boolean,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageCameraStartStopToggle> => {
  const hostId = 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageCameraStartStopToggle = {
    target,
    action: 'startStopToggle',
    isReply: false,
    message: {
      cameraName,
      isActive: active,
    },
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageCameraStartStopToggle>;
};
